import { render } from "./welcomeCard.vue?vue&type=template&id=744fd5a3"
import script from "./welcomeCard.vue?vue&type=script&lang=js"
export * from "./welcomeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__